import React, { useEffect } from "react";
import { TermController } from "../../../../core/config/controllers/TermController";
import TermModal from "./modals/TermModal";
import { AccountHelper } from "../../../../core/config/helpers/AccountHelper";

export default function Terms() {

    const [loading, setLoading] = React.useState(false);
    const [showModal, setShowModal] = React.useState(false);
    const [selected, setSelected] = React.useState({});
    const [terms, setFees] = React.useState([]);

    useEffect(()=>{
        loadTerms();
    },[]);

    const loadTerms = async () => {
        setLoading(true);
        await TermController.List(term => setFees(term));
        setLoading(false);
    }

    function removeFee(term) {
        if (window.confirm("Você tem certeza que deseja excluir este honorário?")) {
            TermController.Delete(term.id, () => {
                setFees(terms.filter(f => f.id !== term.id));
            });
        }
    }

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "32px" }}>
            {/* Honorários */}
            <div className="block block-rounded block-bordered">
                <div className="block-header">
                    <h2 className="block-title">Termos</h2>
                    <div className="block-options">
                        <button className="btn btn-dual" title="Adicionar Termo" onClick={() => setShowModal(true)}>
                            <i className="si si-plus" /> Adicionar Termo
                        </button>
                    </div>
                </div>
                <div className="block-content">
                    <table className="block-table table table-striped table-vcenter">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {terms && terms.map((term, index) => (
                                <tr key={index}>
                                    <td>{term.name}</td>
                                    <td>
                                        <button title="Editar" className="btn btn-dual" onClick={() => setSelected(term) | setShowModal(true)}>
                                            <i className="far fa-edit"/>
                                        </button>
                                        <button title="Excluir" className="btn btn-dual" onClick={() => removeFee(term)}>
                                            <i className="si si-close"/>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <TermModal
                infos={selected}
                show={showModal}
                onHide={() => {
                    setSelected({});
                    setShowModal(false);
                    loadTerms();
                }}
            />
        </div>
    )
}